import useSite from '~/client/hooks/useSite';
import NextLink from '~/client/shared/NextLink';
import type SignupButtonProps from './SignupButtonProps';
import SignupButtonView from './SignupButtonView';

const DefaultSignupButton: FC<SignupButtonProps> = ({
  href = '/register',
  pulse,
  onClick,
}) => {
  const { isBridgeSite } = useSite();
  if (!isBridgeSite && onClick) {
    return <SignupButtonView pulse={pulse} onClick={onClick} />;
  }
  return (
    <NextLink href={href}>
      <SignupButtonView pulse={pulse} />
    </NextLink>
  );
};

export default DefaultSignupButton;
